import { render, staticRenderFns } from "./organizationDetail.vue?vue&type=template&id=eab8742e&scoped=true"
import script from "./organizationDetail.vue?vue&type=script&lang=js"
export * from "./organizationDetail.vue?vue&type=script&lang=js"
import style0 from "./organizationDetail.vue?vue&type=style&index=0&id=eab8742e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab8742e",
  null
  
)

export default component.exports